import request from '@/utils/request'

// 获取 table 数据
export const getTableData = params =>
  request.get('/customer-api/translation/page', params)

export const getAssign = username =>
  request.get(`/masterdata-api/user/active/query/${username}`)

// 新增
export const add = params => request.post('/customer-api/translation', params)

// 文件下载
export const download = params =>
  request.get('/customer-api/file/download', params, { responseType: 'blob' })
